import { SVGProps } from 'react';

const AlarmClockCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 3 2 6m20 0-3-3M6.38 18.7 4 21m13.64-2.33L20 21M9 13l2 2 4-4m5 2a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    />
  </svg>
);
export default AlarmClockCheck;
